// extracted by mini-css-extract-plugin
export default {"wrap":"VN-z","articleImagesWrap":"WN-z","articleImage":"XN-z","singleImage":"YN-z"};